
import React, { useEffect } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

// core components
import ReactTable from "components/ReactTable/ReactTablebep.js";
import { useSelector } from 'react-redux'



function TenantList(props) {
   

  return (
    <>
  
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
            
              <CardBody>
                <ReactTable
                  data= {props.tenantslist}
                  totalpages = {Math.floor(Number(props.total)/Number(props.limit))}
                  pagenumber = {props.pageNumber}
                  pagesize = {props.limit}
                  nextpage = {props.nextpage}
                  previouspage={props.previouspage}
                  pageNumber = {props.pageNumber}
                  setPageNumber={props.setPageNumber}
                  setLimit={props.setLimit}
                  limit={props.limit}
                  columns={[
                                    
                    {
                      Header: "ID",
                      accessor: d => d.tuid,
                    },
                    {
                        Header: "EN",
                        accessor: d => d.nameEN,
                      },
                   /**    {
                        Header: "FR",
                        accessor: d => d.nameFR,
                      },*/
                      {
                        Header: "AR",
                        accessor: d => d.nameAR,
                      },
                      {
                        Header: "email",
                        accessor: d => d.managerid,
                      },
                      {
                        Header: "Cell#",
                        accessor: d => d.cellNumberc,
                      },
                      
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  /*
                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                    */
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TenantList;